var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3362 10.8574H11.3362V16.8574H13.3362V10.8574Z",
    fill: "#EDB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5862 18.8574C13.5862 19.5478 13.0265 20.1074 12.3362 20.1074C11.6458 20.1074 11.0862 19.5478 11.0862 18.8574C11.0862 18.1671 11.6458 17.6074 12.3362 17.6074C13.0265 17.6074 13.5862 18.1671 13.5862 18.8574Z",
    fill: "#EDB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33628 22.8574C2.98928 22.8574 2.66828 22.6774 2.48528 22.3834C2.30228 22.0874 2.28728 21.7204 2.44128 21.4094L11.4413 3.40936C11.7803 2.73236 12.8913 2.73236 13.2303 3.40936L22.2303 21.4094C22.3843 21.7204 22.3693 22.0864 22.1863 22.3834C22.0043 22.6784 21.6833 22.8574 21.3363 22.8574H3.33628ZM19.7183 20.8574L12.3363 6.09436L4.95428 20.8574H19.7183Z",
    fill: "#EDB800"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "alert-triangle.5a692bfe97cc67ebaec6dc4ce0aa3051.svg";